import { Injectable } from '@nestjs/common';
import { NotifyPartyDTO } from './notify-party.dto';
import { NotifyParty } from '../notify-party.entity';

@Injectable()
export class NotifyPartyAdapter {
    public convertDtoToEntity(notifyPartyDto: NotifyPartyDTO, isUpdate: boolean = false): NotifyParty {
        const notifyParty = new NotifyParty();
        notifyParty.notifyPartyId = notifyPartyDto.notifyPartyId;
        notifyParty.notifyPartyName = notifyPartyDto.notifyPartyName;
        notifyParty.isActive = notifyPartyDto.isActive == undefined ? true : notifyPartyDto.isActive;
        if (isUpdate) {
            notifyParty.updatedUser = notifyPartyDto.updatedUser;
        } else {
            notifyParty.isActive = true;
            notifyParty.createdUser = notifyPartyDto.createdUser;
        }
        return notifyParty;
    }

    public convertEntityToDto(notifyPartyObject:NotifyParty):NotifyPartyDTO{
        const notifyPartyDto = new NotifyPartyDTO;
        notifyPartyDto.notifyPartyId = notifyPartyObject.notifyPartyId;
        notifyPartyDto.notifyPartyName = notifyPartyObject.notifyPartyName;
        notifyPartyDto.isActive=notifyPartyObject.isActive;
        notifyPartyDto.createdAt=notifyPartyObject.createdAt;
        notifyPartyDto.updatedAt=notifyPartyObject.updatedAt;
        notifyPartyDto.createdUser=notifyPartyObject.createdUser;
        notifyPartyDto.updatedUser=notifyPartyObject.updatedUser;
        notifyPartyDto.versionFlag=notifyPartyObject.versionFlag;
        return notifyPartyDto;
    }

}